import { Action } from '@/_core/fluxstore/types';
import { StorymapState } from '../types';
import { useStorymapStore } from '../useModule';

const { registerReducer } = useStorymapStore();

export class SetThemeSettingsDialogIsOpen extends Action<StorymapState> {
    public static ACTION_TYPE = 'SetThemeSettingsDialogIsOpen';

    public constructor(public isOpen: boolean) {
        super(SetThemeSettingsDialogIsOpen.ACTION_TYPE);
    }
}

const reducer = (state: StorymapState, action: SetThemeSettingsDialogIsOpen): void => {
    state.isThemeSettingsDialogOpen = action.isOpen;
};

//@ts-ignore
registerReducer(SetThemeSettingsDialogIsOpen.ACTION_TYPE, reducer);
